<div class="video-popup">
  <iframe *ngIf="videoEmbedURL" width="420" height="315"
          [src]="videoEmbedURL" allow="autoplay">
  </iframe>
</div>
